import { FlexCol } from '../../../components/Flex'

import { BossProvider } from '../../../context'
import CustomBasePage from '../../../CustomBasePage'
import UnifiedGeoclaimsList from './UnifiedList'

const GeoclaimsPage = ({ initialTab }: { initialTab: string }) => (
  <BossProvider>
    <CustomBasePage>
      <FlexCol marginY={2} alignItems="stretch">
        <UnifiedGeoclaimsList initialTab={initialTab} />
      </FlexCol>
    </CustomBasePage>
  </BossProvider>
)

export default GeoclaimsPage
